import AWS from "aws-sdk";
// Configure the AWS SDK with your credentials
AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: "ap-southeast-1", // Replace with your desired AWS region, e.g., 'us-east-1'
});
export default AWS;
